// Performing the reset always answers 204: this action carries no business payload, only the
// notification signal.
export type PasswordResetPerformedAction = {
	type: 'PASSWORD_RESET_PERFORMED';
};

export default (): PasswordResetPerformedAction => ({
	type: 'PASSWORD_RESET_PERFORMED',
});
